class SocialsShare {
	static fbShare(url) {
		SocialsShare.openWindow('http://www.facebook.com/sharer.php?u=' + url)
	}

	static twitterShare(url) {
		SocialsShare.openWindow('https://twitter.com/intent/tweet?text=' + url)
	}

	static openWindow(url) {
		const width = 520;
		const height = 520;
		const top = (screen.height / 2) - (width / 2);
		const left = (screen.width / 2) - (height / 2);

		window.open(url, 'sharer', 'top=' + top + ',left=' + left + ',toolbar=0,status=0,width='+width+',height='+height);
	}
}
